import { queryOptions } from '@tanstack/react-query';

import { getConferenceAndEventQuery, getConferencesAndEventsQuery } from './apis';

export const getConferenceAndEventQueryOptions = (id: string) => queryOptions(getConferenceAndEventQuery(id));
export const getConferencesAndEventsQueryOptions = () => queryOptions(getConferencesAndEventsQuery());
